import layout from './layout';
var colGrid = {
  container: {
    width: "".concat(layout.layoutFullWidth, "px")
  },
  row: {
    'margin-left': "".concat(-layout.layoutGutter, "px"),
    'margin-right': "".concat(-layout.layoutGutter, "px"),
    'margin-top': "".concat(layout.layoutGutter, "px")
  },
  col1: {
    width: "".concat(layout.layoutCol1, "px"),
    "float": 'left',
    'margin-left': "".concat(layout.layoutGutter, "px")
  },
  col2: {
    width: "".concat(layout.layoutCol2, "px"),
    "float": 'left',
    'margin-left': "".concat(layout.layoutGutter, "px")
  },
  col3: {
    width: "".concat(layout.layoutCol3, "px"),
    "float": 'left',
    'margin-left': "".concat(layout.layoutGutter, "px")
  },
  col4: {
    width: "".concat(layout.layoutCol4, "px"),
    "float": 'left',
    'margin-left': "".concat(layout.layoutGutter, "px")
  },
  col6: {
    width: "".concat(layout.layoutCol6, "px"),
    "float": 'left',
    'margin-left': "".concat(layout.layoutGutter, "px")
  },
  col12: {
    width: "".concat(layout.layoutCol12, "px"),
    "float": 'left',
    'margin-left': "".concat(layout.layoutGutter, "px")
  }
};
export default colGrid;